import { useDispatch } from 'react-redux';

import { Modals } from '@/constants';
import { AppModal } from '@/containers';
import { uiActions } from '@/store';

import { ListenRejectedModalContainer } from './ListenRejectedModal.container';

export const ListenRejectedModal = () => {
  const dispatch = useDispatch();

  return (
    <AppModal
      modalName={Modals.LISTEN_REJECTED}
      onClose={() => dispatch(uiActions.closeActiveModal())}>
      <ListenRejectedModalContainer />
    </AppModal>
  );
};
